import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { useMount, useSearchParam } from "react-use";
import { Box } from "theme-ui";

import payIcon from "assets/img/ico_pay.png";
import MainLayout from "components/MainLayout";
import ProductList from "pages/Goods/components/ProductList";
import GoodsFooterButton from "pages/Goods/components/GoodsFooterButton";
import { useAppSelector } from "store/hooks";
import { getCartList, getCartTotalCount } from "store/productPayment/cart";
import { AlertModal } from "components/Modal";
import { fetchGoods } from "store/productPayment/goods";
import useNicePayRequest from "hooks/useNicePayRequest";
import { getCartTotalAmount } from "store/productPayment/selectors";

function GoodsPage() {
  const dispatch = useDispatch();
  const history = useHistory();

  const shopid = useSearchParam("shopid");
  const totalCartCount = useAppSelector(getCartTotalCount);
  const amount = useAppSelector(getCartTotalAmount);
  const cartList = useAppSelector(getCartList);

  const [isOpen, setIsOpen] = useState(false);

  const { isLoading, mutate: startPayment } = useNicePayRequest();

  useMount(() => {
    if (shopid) {
      dispatch(fetchGoods({ shopid }));
    }
  });

  function handlePaymentClick() {
    if (totalCartCount > 0 && !isLoading) {
      const firstProductName = cartList[0].productKorName;
      const goodsName =
        totalCartCount > 1
          ? `${firstProductName} 등 ${totalCartCount}개`
          : firstProductName;

      // 나이스페이 결제 시작
      startPayment({ amount, goodsName });
    } else {
      setIsOpen(true);
    }
  }

  return (
    <MainLayout
      contentPadding={0}
      hasBackButton
      title='공뿌마켓 QR결제'
      onGoBack={() => {
        history.push("/home");
      }}
    >
      <Box
        pt='5px'
        sx={{ cursor: "pointer", height: "100%", overflow: "hidden" }}
      >
        <ProductList />
        <GoodsFooterButton
          icon={payIcon}
          text='결제하기'
          onClick={handlePaymentClick}
        />
      </Box>
      <AlertModal
        isOpen={isOpen}
        message='결제할 상품 수량이 0 입니다.'
        onConfirm={() => setIsOpen(false)}
      />
    </MainLayout>
  );
}

export default GoodsPage;
